import { createContext } from "react";
import { IAdaptivePracticeContext, IInfo } from "../features/adaptivePractice/interface/interface";
export const AppContext = createContext({ windowHeight: window.innerHeight, windowWidth: window.innerWidth, messageForParent: (type: string, data: any) => { }, navigateTo: (path: string) => { } });


export const AdaptivePracticeContext = createContext<IAdaptivePracticeContext>({
    notificationMessage: '',
    streaks: 0,
    coins: 0,
    isSafeZone: false,
    isLastQuestion: false,
    meter: { percentage: 0, level: '' },
    isLoader: false,
    isCoinAnimation: false,
    isShowStartPopup: false,
    isShowAdaptivePopup: false,
    isCloseFromClick: false,
    engineObj: {},
    reviewMode: { isAttempted: false, isCorrect: false, userInput: [], correctAnswer: [] },
    loadContent: () => { },
    saveQuestionResponse: (answerObj: { givenAnswer: any, actualAnswer: any, isCorrectAns: Boolean }, clickCount: number) => { },
    getPopUpInfo: () => { return { totalAttemptedQuestions: 0, accuracy: 0, heading: '', showAnimation: false, streaks: 0, completedStatusPercentage: 0, isShowStartPopup: false, isSafeZone: false, isCloseFromClick: false } },
    setShowAdaptivePopup: (isCloseFromClick?: boolean) => { },
    setShowStartPopup: (status: boolean) => { },
    onclose: () => { },
});
export const AdaptiveChallengeContext = createContext({ isChallenge: false, questions: [], date: '', attempted: 0, total: 0, correct: 0 });
export const renderedContext: any = createContext({
    explanation: {},
    hint: {},
    isSafeZone: false,
    isLastQuestion: false,
    reviewMode: { isAttempted: false, isCorrect: false, userInput: [], correctAnswer: [] },
    meter: { percentage: 0, level: '' },
    saveQuestionResponse: () => { },
    /* Neither registerCommit nor markTouched is here on purpose. The frame hands them out only on a
       screen that is handed in - see PlayFrame - and the parts read their ABSENCE as "answering is
       the answer", which is how every screen behaved before the quiz existed. A no-op default would
       say the opposite: that the answer is being held for a Save button that does not exist. */
    onFinish: () => { },
    loadContent: () => { }
});
